import clsx from "classnames";
import classes from "./styles.module.scss";
import { getQuicklinks } from "@/getters/getQuicklinks";

export const QuickLinks = ({ className }) => {
  const quicklinks = getQuicklinks();

  return (
    <div className={clsx(className, classes.quicklinks)}>
      <h3 className="h6">Quick links</h3>
      {quicklinks
        .filter((i) => i.enabled)
        .map((i) => (
          <a
            key={i.id}
            href={i.url}
            target={i.new_tab ? "_blank" : "_self"}
            dangerouslySetInnerHTML={{ __html: i.label }}
          />
        ))}
    </div>
  );
};
